import { createContext, useContext, useEffect, useState } from "react";

const CartContext = createContext(null);
const STORAGE_KEY = "cbm_cart";

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch {
      return [];
    }
  });
  const [open, setOpen] = useState(false);

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
  }, [items]);

  const add = (p) =>
    setItems((prev) => {
      const ex = prev.find((i) => i.lookup_key === p.lookup_key);
      if (ex) {
        return prev.map((i) =>
          i.lookup_key === p.lookup_key
            ? { ...i, quantity: Math.min(i.quantity + 1, p.stock) }
            : i
        );
      }
      return [
        ...prev,
        { lookup_key: p.lookup_key, slug: p.slug, name: p.name, price_cents: p.price_cents, image: p.image, stock: p.stock, quantity: 1 },
      ];
    });

  const remove = (lk) => setItems((prev) => prev.filter((i) => i.lookup_key !== lk));

  const setQty = (lk, q) =>
    setItems((prev) =>
      q <= 0
        ? prev.filter((i) => i.lookup_key !== lk)
        : prev.map((i) => (i.lookup_key === lk ? { ...i, quantity: Math.min(q, i.stock) } : i))
    );

  const clear = () => setItems([]);
  const count = items.reduce((s, i) => s + i.quantity, 0);
  const total = items.reduce((s, i) => s + i.price_cents * i.quantity, 0);

  return (
    <CartContext.Provider value={{ items, add, remove, setQty, clear, count, total, open, setOpen }}>
      {children}
    </CartContext.Provider>
  );
}

export const useCart = () => useContext(CartContext);
